import { Suspense, lazy, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useStoreActions } from "easy-peasy";
import Spinner from "./shared/spinner/Spinner";
import Login from "./login/Login";
import PrivateRoute from "./shared/private-route/PrivateRoute";
import WaitlistPage from "./dashboard/waitlist/WaitlistPage";
const Dashboard = lazy(() => import("./dashboard/Dashboard"));
const Users = lazy(() => import("./dashboard/users/Users"));
const UserDetail = lazy(
  () => import("./dashboard/users/user-detail/UserDetail"),
);

function AuthInit() {
  const { initAuthListener } = useStoreActions((actions) => actions.auth);
  useEffect(() => {
    initAuthListener();
  }, [initAuthListener]);

  return null;
}

function App() {
  return (
    <>
      <AuthInit />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            borderRadius: "10px",
            background: "#222",
            color: "#fff",
            fontWeight: 500,
            fontSize: "14px",
            boxShadow: "0 4px 32px rgba(0,0,0,0.12)",
          },
        }}
      />

      <Suspense fallback={<Spinner />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Navigate to="/admin/users" replace />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          >
            <Route
              path="users"
              element={
                <PrivateRoute>
                  <Users />
                </PrivateRoute>
              }
            />
            <Route
              path="users/:userId"
              element={
                <PrivateRoute>
                  <UserDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="waitlist"
              element={
                <PrivateRoute>
                  <WaitlistPage />
                </PrivateRoute>
              }
            />
          </Route>
          <Route
            path="*"
            element={
              <PrivateRoute>
                <Navigate to="/admin/users" replace />
              </PrivateRoute>
            }
          />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
